import PetCommunityBanner from "../PetCommunityBanner";
import PetTagFooter from "../PetTagFooter";

function FooterWithBanner() {
  return (
    <div className="relative w-full">
      <div className="absolute -top-[8%] md:-top-[12%] left-[2%] lg:left-[10%]  2xl:left-[20%] w-[96%] lg:w-[80%] 2xl:w-[60%]">
        <PetCommunityBanner />
      </div>
      <PetTagFooter />
    </div>
  );
}

export default FooterWithBanner;
